import React, {useEffect} from 'react'
import './header.css'
import logo from '../../imgs/logo_big.jpg'
import { Link, NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartShopping } from '@fortawesome/free-solid-svg-icons'
import { useAppSelector } from '../../hooks/redux'
import TopBanner from '../TopBanner/TopBanner'
import Search from '../Search/Search'
import {useTranslation} from "react-i18next";
import {ImArrowDown} from "react-icons/im"
import {AiOutlineMenuUnfold} from "react-icons/ai"

const Header = () => {
    const {t} = useTranslation()
    const { totalProductsCount } = useAppSelector((state) => state.cart)

    const handleSlideRight = () => {
        const leftSlide = document.querySelector<HTMLDivElement>('.left-slide')
        if(leftSlide){
            leftSlide.style.transform = "translate(0)"
        }
    }

    return (
        <div className="header">
            <AiOutlineMenuUnfold onClick={handleSlideRight} className="slider_arrow" />
            <TopBanner />
            <div className="header_content app_container">
                <div className="logo-container">
                    <div className="logo-container-left">
                        <Link to="/">
                            <img src={logo} alt="" />
                        </Link>
                        <p className="logo-text">
                            <b>{t("general.specialized_online_store")}</b>
                        </p>
                    </div>
                    <NavLink to="/cart" className="logo_cart_wrap">
                        <FontAwesomeIcon icon={faCartShopping} className="logo_cart" />
                        {totalProductsCount > 0 && (
                            <span className="logo_cart_count">{totalProductsCount}</span>
                        )}
                    </NavLink>
                </div>
                <Search />
                <div className="header_cart">
                    <NavLink className="header_cart_link" to="/cart">
                        <span className="header_cart_icon_wrap">
                            <FontAwesomeIcon icon={faCartShopping} className="header_cart_icon" />
                            {totalProductsCount > 0 && (
                                <span className="header_cart_count">{totalProductsCount}</span>
                            )}
                        </span>
                        {t("general.cart")}
                    </NavLink>
                </div>
            </div>
            {/*<Slider/>*/}
        </div>
    )
}

export default Header
